# Изменение ширины в meta viewport, чтобы на планшетах (начиная с вертикального iPad'a и шире)
# показывалась десктопная версия

$ ->
  viewport    = $('meta[name="viewport"]')
  fixed_width = 1100

  window.onload = ->
    if window.actAsDesktop()
      viewport.attr("content", "width=#{fixed_width}, initial-scale=1")